import echarts from "echarts";

export function showAnalysis_Index(obj){
    const myChart = echarts.init(document.getElementById(obj));
    var option = {
      tooltip: {
        formatter: '{a} <br/>{b} : {c}%'
      },
      color:['#2F5597','#3A68BC','#6A8ED0','#9CB4E0','#B6C8E8','#D0DBF0','#DCE5F4'],
      series: [
        {
          name: 'Pressure',
          type: 'gauge',
          axisLine: {
            lineStyle: {
              width: 30,
              color: [
                [0.25, '#2F5597'],
                [0.5, '#3A68BC'],
                [0.75, '#6A8ED0'],
                [1, '#9CB4E0']
              ]
            }
          },
          detail: {
            formatter: '{value}%'
          },
          data: [
            {
              value: 92,
              name: '任务执行准期率'
            }
          ]
        }
      ]
    };
    //   console.log('mychart',myChart)
    myChart.setOption(option);
}